export default __webpack_public_path__ + "pgnv-assets/70b436b60ec1d3b3d62a5d7c6a18d981.svg";